/**
 * Query Key factory for all masterclass queries.
 *
 * @module Masterclass
 */

export const masterclassQKeys = {
  all: () => ["masterclass"] as const,

  classes: () => [...masterclassQKeys.all(), "classes"] as const,

  classesWithFilters: (filters: {
    provider_id?: string;
    search?: string;
  }) => [...masterclassQKeys.classes(), { ...filters }] as const,

  classDetails: (id: string) => [...masterclassQKeys.all(), "details", id] as const,

  enrollments: () => [...masterclassQKeys.all(), "enrollments"] as const,

  enrollmentsByClass: (classId: string) =>
    [...masterclassQKeys.enrollments(), "class", classId] as const,
};
